import React, {PureComponent} from "react"

import {H2} from "@irati/ui/src/Headings"
import {FormattedMessage} from "@irati/utils/lang"

import {IntroText} from "../../IntroText"

class TenantWalletIntro extends PureComponent {
  render() {
    return (
      <>
        <H2><FormattedMessage id="wallet.tenant.topUp.header" /></H2>
        <IntroText message="wallet.tenant.topUp.text" />
      </>
    )
  }
}

export default TenantWalletIntro
